import { downloadFile } from "@/lib/download-file";
import { ACTION_LINK_CLASS } from "@/lib/link-styles";

interface UnsupportedFilePreviewProps {
	/** Content-Disposition: attachment 付きの URL。この画面では表示せずダウンロードのみ行う。 */
	downloadUrl: string;
	filename: string;
	message: string;
}

export function UnsupportedFilePreview({
	downloadUrl,
	filename,
	message,
}: UnsupportedFilePreviewProps) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: 12,
				height: "100%",
				padding: "var(--text-display)",
				color: "var(--fg-3)",
			}}
		>
			<svg
				width="36"
				height="36"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
				<polyline points="14 2 14 8 20 8" />
			</svg>
			<p style={{ fontSize: "var(--text-caption)", margin: 0, textAlign: "center" }}>{message}</p>
			<button
				type="button"
				onClick={() => downloadFile(downloadUrl)}
				className={ACTION_LINK_CLASS}
				style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
			>
				<svg
					width="13"
					height="13"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
					<polyline points="7 10 12 15 17 10" />
					<line x1="12" y1="15" x2="12" y2="3" />
				</svg>
				{filename}をダウンロード
			</button>
		</div>
	);
}
